<template>
  <nav class="container-fluid Navbar" :class="{ 'is-opaque': !scrollIsHome }">

    <div class="row d-md-none">
      <div class="col d-flex justify-content-end">
        <div 
          class="Hamburger mt-3 mr-2" 
          :class="{ 'is-open': menuIsOpen }"
          @click="functionHandler(toggleMenu, toggleScroll)"></div>

        <transition name="slide-right--fade">
          <div 
            class="Modal"
            v-if="menuIsOpen">
            <ul class="Modal-navList">
              
              <li class="Modal-navList-item" @click="mobileNavigation('products')">
                Multitouch
              </li>
              <li class="Modal-navList-item" @click="mobileNavigation('story')">
                Story
              </li>
              <li class="Modal-navList-item" @click="mobileNavigation('creativeServices')">
                Creative Services
              </li>
              <li class="Modal-navList-item" @click="mobileNavigation('contact')">
                Contact
              </li>
              <li>
                <svg
                  class="Modal-navList-logo"
                  version="1.1" 
                  id="svg-logo-navbar"  
                  xmlns="http://www.w3.org/2000/svg" 
                  xmlns:xlink="http://www.w3.org/1999/xlink" 
                  x="0px" y="0px" 
                  viewBox="0 0 223 84" 
                  style="enable-background:new 0 0 223 84;" 
                  xml:space="preserve">
                <g id="XMLID_93_">
                  <path id="XMLID_113_" class="st0" d="M73.7,27.6v55.3h-13v-5.4c-1.8,2.3-3.5,3.8-5,4.6c-2,1-4.2,1.6-6.7,1.6
                    c-4.9,0-8.7-1.9-11.3-5.6c-2.6-3.8-3.9-8.3-3.9-13.7c0-6,1.4-10.6,4.3-13.8c2.9-3.2,6.5-4.8,11-4.8c2.2,0,4.1,0.4,5.9,1.1
                    c1.8,0.7,3.3,1.8,4.7,3.3V27.6H73.7z M59.8,64.7c0-2.8-0.6-5-1.8-6.4s-2.7-2.1-4.6-2.1c-1.6,0-3,0.7-4.1,2s-1.6,3.6-1.6,6.8
                    c0,3,0.6,5.1,1.7,6.5c1.1,1.4,2.5,2.1,4.2,2.1c1.8,0,3.3-0.7,4.4-2.1C59.2,70.1,59.8,67.8,59.8,64.7z"/>
                  <path id="XMLID_109_" class="st0" d="M118.3,68.2H90.4c0.3,2.2,0.9,3.9,1.8,5c1.3,1.6,3.1,2.4,5.3,2.4c1.4,0,2.7-0.3,3.9-1
                    c0.8-0.4,1.6-1.2,2.4-2.3l13.7,1.3c-2.1,3.6-4.6,6.3-7.6,7.8c-3,1.6-7.2,2.4-12.7,2.4c-4.8,0-8.6-0.7-11.3-2
                    c-2.8-1.4-5-3.5-6.8-6.5c-1.8-2.9-2.7-6.4-2.7-10.4c0-5.7,1.8-10.3,5.4-13.8s8.6-5.3,15-5.3c5.2,0,9.3,0.8,12.3,2.4
                    c3,1.6,5.3,3.8,6.9,6.8s2.4,6.9,2.4,11.6v1.6H118.3z M104.1,61.6c-0.3-2.7-1-4.6-2.2-5.8s-2.7-1.7-4.6-1.7c-2.2,0-4,0.9-5.3,2.6
                    c-0.8,1.1-1.4,2.7-1.6,4.9H104.1z"/>
                  <path id="XMLID_105_" class="st0" d="M158.9,82.9h-13V77c-1.9,2.4-3.9,4.1-5.9,5.2c-2,1-4.4,1.5-7.3,1.5c-3.8,0-6.8-1.1-9-3.4
                    s-3.3-5.8-3.3-10.6v-23h14v19.9c0,2.3,0.4,3.9,1.3,4.8c0.8,1,2,1.4,3.5,1.4c1.7,0,3-0.6,4.1-1.9s1.6-3.6,1.6-6.9V46.7h13.9
                    L158.9,82.9L158.9,82.9z"/>
                  <path id="XMLID_102_" class="st0" d="M161.5,46.7h13V52c1.9-2.2,3.8-3.8,5.7-4.7s4.2-1.4,6.9-1.4c2.9,0,5.2,0.5,6.9,1.5
                    s3.1,2.5,4.1,4.6c2.2-2.4,4.2-4,6-4.8c1.8-0.9,4-1.3,6.6-1.3c3.9,0,6.9,1.2,9.1,3.5c2.2,2.3,3.3,5.9,3.3,10.8V83h-13.9V62.2
                    c0-1.6-0.3-2.9-1-3.7c-0.9-1.3-2.1-1.9-3.5-1.9c-1.6,0-2.9,0.6-3.9,1.8s-1.5,3.1-1.5,5.7v18.7h-13.9v-20c0-1.6-0.1-2.7-0.3-3.2
                    c-0.3-0.9-0.8-1.6-1.5-2.2c-0.7-0.6-1.6-0.8-2.6-0.8c-1.6,0-2.9,0.6-3.9,1.8s-1.5,3.2-1.5,5.9v18.5h-13.9V46.7H161.5z"/>
                  <g id="XMLID_97_">
                    <circle id="XMLID_24_" class="st0" cx="24.4" cy="33.6" r="7.7"/>
                    <g id="XMLID_98_">
                      <circle id="XMLID_21_" class="st0" cx="24.4" cy="33.6" r="7.7"/>
                      <path id="XMLID_20_" class="st0" d="M17.6,43.2v39.7h13.9V43c-2,1.5-4.4,2.3-7,2.3C21.9,45.4,19.5,44.6,17.6,43.2z"/>
                    </g>
                  </g>
                  <rect id="XMLID_17_" x="22.8" y="0.3" class="st0" width="3.3" height="19"/>
                  
                    <rect id="XMLID_11_" x="6.2" y="7.2" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -9.5175 10.4314)" class="st0" width="3.3" height="19"/>
                  
                    <rect id="XMLID_5_" x="31.4" y="15.1" transform="matrix(0.7071 -0.7071 0.7071 0.7071 0.1533 33.8305)" class="st0" width="19" height="3.3"/>
                </g>
                </svg>
              </li>
            </ul>
          </div>
        </transition>
      </div>
    </div>

    <div class="container d-none d-md-block">
      <div class="row">
        <div class="col-lg-8 mx-auto">
          <ul class="Navbar-list mb-0 pr-0">

            <li 
              class="Navbar-list-item Highlight"
              :class="{ 
                'Highlight--emerald': currentSection === 'products', 
                'is-opaque': !scrollIsHome }"
              @click="jumpToSection('products')">
              Multitouch
            </li>

            <li 
              class="Navbar-list-item Highlight"
              :class="{ 
                'Highlight--emerald': currentSection === 'products', 
                'is-opaque': !scrollIsHome }"
                @click="jumpToSection('story')">
              Story
            </li>
            
            <li class="Navbar-list-item" @click="jumpToHome">
              <!-- <img class="Navbar-list-logo" src="./../assets/images/ideum-logo.svg" width="auto" height="30px"> -->
              <svg version="1.1" id="Layer_1" 
                class="Navbar-list-logo" 
                :class="{ 'is-opaque': !scrollIsHome }" 
                xmlns="http://www.w3.org/2000/svg" 
                xmlns:xlink="http://www.w3.org/1999/xlink" 
                x="0px" y="0px" 
                viewBox="0 0 223 84" 
                style="enable-background:new 0 0 223 84;" 
                xml:space="preserve">
                <g id="XMLID_93_">
                  <path id="XMLID_113_" class="st0" d="M73.7,27.6v55.3h-13v-5.4c-1.8,2.3-3.5,3.8-5,4.6c-2,1-4.2,1.6-6.7,1.6
                    c-4.9,0-8.7-1.9-11.3-5.6c-2.6-3.8-3.9-8.3-3.9-13.7c0-6,1.4-10.6,4.3-13.8c2.9-3.2,6.5-4.8,11-4.8c2.2,0,4.1,0.4,5.9,1.1
                    c1.8,0.7,3.3,1.8,4.7,3.3V27.6H73.7z M59.8,64.7c0-2.8-0.6-5-1.8-6.4s-2.7-2.1-4.6-2.1c-1.6,0-3,0.7-4.1,2s-1.6,3.6-1.6,6.8
                    c0,3,0.6,5.1,1.7,6.5c1.1,1.4,2.5,2.1,4.2,2.1c1.8,0,3.3-0.7,4.4-2.1C59.2,70.1,59.8,67.8,59.8,64.7z"/>
                  <path id="XMLID_109_" class="st0" d="M118.3,68.2H90.4c0.3,2.2,0.9,3.9,1.8,5c1.3,1.6,3.1,2.4,5.3,2.4c1.4,0,2.7-0.3,3.9-1
                    c0.8-0.4,1.6-1.2,2.4-2.3l13.7,1.3c-2.1,3.6-4.6,6.3-7.6,7.8c-3,1.6-7.2,2.4-12.7,2.4c-4.8,0-8.6-0.7-11.3-2
                    c-2.8-1.4-5-3.5-6.8-6.5c-1.8-2.9-2.7-6.4-2.7-10.4c0-5.7,1.8-10.3,5.4-13.8s8.6-5.3,15-5.3c5.2,0,9.3,0.8,12.3,2.4
                    c3,1.6,5.3,3.8,6.9,6.8s2.4,6.9,2.4,11.6v1.6H118.3z M104.1,61.6c-0.3-2.7-1-4.6-2.2-5.8s-2.7-1.7-4.6-1.7c-2.2,0-4,0.9-5.3,2.6
                    c-0.8,1.1-1.4,2.7-1.6,4.9H104.1z"/>
                  <path id="XMLID_105_" class="st0" d="M158.9,82.9h-13V77c-1.9,2.4-3.9,4.1-5.9,5.2c-2,1-4.4,1.5-7.3,1.5c-3.8,0-6.8-1.1-9-3.4
                    s-3.3-5.8-3.3-10.6v-23h14v19.9c0,2.3,0.4,3.9,1.3,4.8c0.8,1,2,1.4,3.5,1.4c1.7,0,3-0.6,4.1-1.9s1.6-3.6,1.6-6.9V46.7h13.9
                    L158.9,82.9L158.9,82.9z"/>
                  <path id="XMLID_102_" class="st0" d="M161.5,46.7h13V52c1.9-2.2,3.8-3.8,5.7-4.7s4.2-1.4,6.9-1.4c2.9,0,5.2,0.5,6.9,1.5
                    s3.1,2.5,4.1,4.6c2.2-2.4,4.2-4,6-4.8c1.8-0.9,4-1.3,6.6-1.3c3.9,0,6.9,1.2,9.1,3.5c2.2,2.3,3.3,5.9,3.3,10.8V83h-13.9V62.2
                    c0-1.6-0.3-2.9-1-3.7c-0.9-1.3-2.1-1.9-3.5-1.9c-1.6,0-2.9,0.6-3.9,1.8s-1.5,3.1-1.5,5.7v18.7h-13.9v-20c0-1.6-0.1-2.7-0.3-3.2
                    c-0.3-0.9-0.8-1.6-1.5-2.2c-0.7-0.6-1.6-0.8-2.6-0.8c-1.6,0-2.9,0.6-3.9,1.8s-1.5,3.2-1.5,5.9v18.5h-13.9V46.7H161.5z"/>
                  <g id="XMLID_97_">
                    <circle id="XMLID_24_" class="st0" cx="24.4" cy="33.6" r="7.7"/>
                    <g id="XMLID_98_">
                      <circle id="XMLID_21_" class="st0" cx="24.4" cy="33.6" r="7.7"/>
                      <path id="XMLID_20_" class="st0" d="M17.6,43.2v39.7h13.9V43c-2,1.5-4.4,2.3-7,2.3C21.9,45.4,19.5,44.6,17.6,43.2z"/>
                    </g>
                  </g>
                  <rect id="XMLID_17_" x="22.8" y="0.3" class="st0" width="3.3" height="19"/>
                  
                    <rect id="XMLID_11_" x="6.2" y="7.2" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -9.5175 10.4314)" class="st0" width="3.3" height="19"/>
                  
                    <rect id="XMLID_5_" x="31.4" y="15.1" transform="matrix(0.7071 -0.7071 0.7071 0.7071 0.1533 33.8305)" class="st0" width="19" height="3.3"/>
                </g>
                </svg>
            </li>

            <li 
              class="Navbar-list-item Highlight"
              :class="{ 
                'Highlight--emerald': currentSection === 'products', 
                'is-opaque': !scrollIsHome }"
                @click="jumpToSection('creativeServices')">
              Creative Services
            </li>

            <li 
              class="Navbar-list-item Highlight"
              :class="{ 
                'Highlight--emerald': currentSection === 'products', 
                'is-opaque': !scrollIsHome }"
                @click="jumpToSection('contact')">
              Contact
            </li>

          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import jump from 'jump.js'
export default {
  data () {
    return {
      currentSection: null,
      menuIsOpen: false,
      scrollIsHome: true
    }
  },

  computed: {
    sections () {
      const sectionNodes = document.querySelectorAll('.Section')
      return sectionNodes.length
    }
  },

  created () {
    window.addEventListener('scroll', this.menuCollapse)
  },

  mounted () {
    console.dir(document.querySelectorAll('.Section'))
    this.menuCollapse()
  },

  methods: {
    functionHandler (fn1, fn2) {
      fn1()
      fn2()
    },

    jumpToHome () {
      jump('#app')
    },

    jumpToSection (section) {
      const selector = '.Section--' + section
      jump(selector, {
        offset: -80
      })
    },

    menuCollapse () {
      const scrollY = document.body.scrollTop || window.pageYOffset
      const width = document.body.offsetWidth
      if (scrollY > 0 && width >= 767) {
        this.scrollIsHome = false
      } else {
        this.scrollIsHome = true
      }
    },

    mobileNavigation (section) {
      this.toggleMenu()
      this.toggleScroll()
      this.jumpToSection(section)
    },

    toggleScroll () {
      const body = document.getElementsByTagName('body')
      if (this.menuIsOpen) {
        body[0].setAttribute('style', 'overflow: hidden;')
      } else {
        body[0].removeAttribute('style', 'overflow: hidden;')
      }
    },

    toggleMenu () {
      this.menuIsOpen = !this.menuIsOpen
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../assets/_variables.scss';

.Hamburger {
  background-color: #fafafa;
  border-radius: 50%;
  box-shadow: 0 3px 30px rgba(0, 0, 0, .1);
  position: relative;
  transition: $transitionPrimary;
  width: 50px;
  height: 50px;
  z-index: 1;
  // hamburger open
  &.is-open {
    background-color: $colorPlum;
    &::after {
      background: $colorEmerald;
      content: '';
      margin: auto;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      transform: rotate(-45deg);
      width: 60%;
      height: 4px;
    }
    &::before {
      background: $colorEmerald;
      content: '';
      margin: auto;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      transform: rotate(45deg);
      width: 60%;
      height: 4px;
    }
  }
  // hamburger closed
  &::after {
    background: $colorPlum;
    content: '';
    margin: 1em auto 1em auto;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transition: $transitionPrimary;
    width: 60%;
    height: 4px;
  }
  &::before {
    background: $colorPlum;
    content: '';
    margin: auto auto 1em auto;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transition: $transitionPrimary;
    width: 60%;
    height: 4px;
  }
}

.Modal {
  background-color: $colorWhite;
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
}

.Modal-navList {
  color: $colorPlum;
  display: flex;
  flex-direction: column;
  font-size: 4vmax;
  justify-content: center;
  letter-spacing: 1px;
  list-style-type: none;
  margin: -5vh 0 0 0;
  padding: 0 0 0 15vw;
  text-transform: uppercase;
  width: auto;
  height: 100%;
}

.Modal-navList-item {
  padding: 0 0 1em 0;
}

.Modal-navList-logo {
  fill: $colorPlum;
  width: auto;
  height: 50px;
}

.Navbar {
  background-color: transparent;
  color: #fff;
  position: fixed;
  transition: $transitionPrimary;
  z-index: $z-navbar;
  &.is-opaque {
    background-color: $colorWhite;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, .1);
  }
}

.Navbar-list {
  align-items: center;
  display: flex;
  justify-content: space-between;
  letter-spacing: 1px;
  list-style-type: none;
  padding: 0;
  text-transform: uppercase;
  transition: $transitionPrimary;
  height: $navbarHeight;
}

.Navbar-list-item {
  cursor: pointer;
  position: relative;
  transition: $transitionPrimary;
  &:hover {
    color: $colorEmerald;
  }
  &.is-opaque {
    color: $colorPlum;
    &:hover {
      color: $colorEmerald;
    }
  }
}

.Navbar-list-logo {
  fill: $colorWhite;
  margin-top: -10px;
  transition: $transitionPrimary;
  width: auto;
  height: 30px;
  &:hover {
    fill: $colorEmerald;
  }
  &.is-opaque {
    fill: $colorPlum;
    &:hover {
      fill: $colorEmerald;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue